import { Award, Target, Users } from 'lucide-react';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

// 公司图片
const companyImages = [
  { src: '/img/2831768537378_.pic.jpg', alt: 'Company Image 1' },
  { src: '/img/2841768537379_.pic.jpg', alt: 'Company Image 2' },
  { src: '/img/2851768537380_.pic.jpg', alt: 'Company Image 3' },
  { src: '/img/2861768537381_.pic.jpg', alt: 'Company Image 4' },
  { src: '/img/2871768537382_.pic.jpg', alt: 'Company Image 5' },
  { src: '/img/2881768537383_.pic.jpg', alt: 'Company Image 6' },
  { src: '/img/2891768537384_.pic.jpg', alt: 'Company Image 7' },
  { src: '/img/2901768537385_.pic.jpg', alt: 'Company Image 8' },
  { src: '/img/2911768537386_.pic.jpg', alt: 'Company Image 9' },
  { src: '/img/2921768537387_.pic.jpg', alt: 'Company Image 10' },
  { src: '/img/3011768541742_.pic_hd.jpg', alt: 'Company Image 11' },
  { src: '/img/3021768541744_.pic_hd.jpg', alt: 'Company Image 12' },
  { src: '/img/3041768541745_.pic_hd.jpg', alt: 'Company Image 13' },
  { src: '/img/3051768541746_.pic_hd.jpg', alt: 'Company Image 14' },
  { src: '/img/3181768545488_.pic.jpg', alt: 'Company Image 15' },
  { src: '/img/3191768545496_.pic.jpg', alt: 'Company Image 16' },
  { src: '/img/3211768545557_.pic.jpg', alt: 'Company Image 17' },
  { src: '/img/3221768545567_.pic.jpg', alt: 'Company Image 18' },
];

export function AboutUs() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openLightbox = (index: number) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const goToPrevious = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? companyImages.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentImageIndex((prev) => (prev === companyImages.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        {/* <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl mb-6">About Us</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            SHANGHAI DAOCHIN MECHANICAL EQUIPMENT CO., LTD. (DCH) - Leading the industry for over 20 years, providing high-quality engineering parts and components
          </p>
        </div> */}

        {/* Company Gallery */}
        <div className="mb-16">
          <h2 className="text-3xl text-center mb-4">Company Gallery</h2>
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            Take a look at our facilities, team, and the quality products we deliver to customers worldwide.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {companyImages.map((image, index) => (
              <div
                key={index}
                onClick={() => openLightbox(index)}
                className="relative aspect-square rounded-lg overflow-hidden shadow-md cursor-pointer group"
              >
                <ImageWithFallback
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity text-sm">
                    Click to view
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Company Profile */}
        <div className="mb-16">
          <h2 className="text-3xl mb-6">Company Profile</h2>
          <p className="text-gray-700 mb-4">
            SHANGHAI DAOCHIN MECHANICAL EQUIPMENT CO., LTD. (DCH) was established in 2004, growing from a small local supplier to a trusted international industrial parts supplier. Our journey has always been driven by quality, innovation, and customer satisfaction.
          </p>
          <p className="text-gray-700 mb-4">
            We specialize in providing high-quality hydraulic parts, bearings, seals, gears, and other critical components to industries worldwide. With our extensive product catalog and technical expertise, we ensure customers always find solutions that meet their needs.
          </p>
          <p className="text-gray-700">
            With advanced production facilities and a professional team, we continue to set excellence standards in the engineering parts industry.
          </p>
        </div>

        {/* Core Values */}
        <div className="mb-16">
          <h2 className="text-3xl text-center mb-12">Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <Award className="mx-auto mb-4 text-primary" size={48} />
              <h3 className="text-2xl mb-4">Quality First</h3>
              <p className="text-gray-700">
                Every product meets strict quality standards and undergoes comprehensive testing before reaching customers.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <Target className="mx-auto mb-4 text-primary" size={48} />
              <h3 className="text-2xl mb-4">Continuous Innovation</h3>
              <p className="text-gray-700">
                We continuously invest in R&D to bring cutting-edge solutions to the market.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <Users className="mx-auto mb-4 text-primary" size={48} />
              <h3 className="text-2xl mb-4">Customer First</h3>
              <p className="text-gray-700">
                Our professional support team ensures every customer receives personalized service and expert guidance.
              </p>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div className="bg-primary text-primary-foreground rounded-lg p-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl mb-2">20+</div>
              <div className="text-lg">Years Experience</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl mb-2">5000+</div>
              <div className="text-lg">Products</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl mb-2">50+</div>
              <div className="text-lg">Countries Served</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl mb-2">10000+</div>
              <div className="text-lg">Global Clients</div>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center">
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
          >
            <X size={32} />
          </button>
          
          <button
            onClick={goToPrevious}
            className="absolute left-4 text-white hover:text-gray-300 transition-colors p-2"
          >
            <ChevronLeft size={40} />
          </button>
          
          <div className="max-w-5xl max-h-[85vh] w-full h-full flex items-center justify-center px-16">
            <ImageWithFallback
              src={companyImages[currentImageIndex].src}
              alt={companyImages[currentImageIndex].alt}
              className="max-w-full max-h-full object-contain"
            />
          </div>
          
          <button
            onClick={goToNext}
            className="absolute right-4 text-white hover:text-gray-300 transition-colors p-2"
          >
            <ChevronRight size={40} />
          </button>
          
          {/* Image counter */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-sm">
            {currentImageIndex + 1} / {companyImages.length}
          </div>
        </div>
      )}
    </div>
  );
}
